module.exports = __webpack_public_path__ + "img/EPBusiness3.26d1565b.png";